var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!!_vm.dateTime)?[_c('div',[_vm._v(" "+_vm._s(_vm.parseDate(_vm.dateTime, this.$config.DATE_FORMAT))+" ")]),_c('div',{staticClass:"text-gray"},[_vm._v(" "+_vm._s(_vm.parseDate(_vm.dateTime, this.$config.TIME_FORMAT))+" ")])]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }